export const allowedCustomEvents = [3];
